import type { ReceiptChannel } from '@chukua/common';
import { Select } from 'antd';
import { useCompanyAccountOptions } from './use-company-account-options';

interface CompanyAccountSelectProps {
  /** Decides which accounts are offered: a cheque or transfer lands in a bank account, M-Pesa on a paybill or till. */
  channel: ReceiptChannel | undefined;
  id?: string;
  value?: string;
  onChange?: (value: string) => void;
}

function emptyText(status: string): string {
  if (status === 'error') return 'Could not load the accounts';
  if (status === 'loading') return 'Loading…';
  return 'No active account takes this channel. Add one in Company settings.';
}

/** The company's own active accounts for the receipt's channel, all listed on open. */
export function CompanyAccountSelect({ channel, id, value, onChange }: CompanyAccountSelectProps) {
  const state = useCompanyAccountOptions(channel);
  const options = state.status === 'loaded' ? state.options : [];

  return (
    <Select
      id={id}
      value={value}
      onChange={onChange}
      disabled={!channel}
      loading={state.status === 'loading'}
      placeholder={channel ? 'Choose the account it was paid into' : 'Choose the channel first'}
      options={options.map((option) => ({ value: option.id, label: `${option.name} · ${option.detail}` }))}
      notFoundContent={emptyText(state.status)}
    />
  );
}
